export default function RouteDivider() {
  return (
    <div className="route-divider" style={{ margin: '0 6vw' }} aria-hidden="true">
      <span className="traveler" />
      <span className="traveler delay" />
    </div>
  );
}
